export const primarycolor = "#fb0000"
// export const primarycolor = "#6a1b9a";
// export const primarycolor = "#ffd102";
export const productcolor = "#00588e";
export const secondarycolor = "#00588e";
export const semiprimarycolor = "gold"
export const columncolor = "rgb(231, 226, 226)";
export const columncoloralt = "#e0c2f3"
export const white = "white"
export const lightsilver = '#edefef'
